module.exports = __webpack_public_path__ + "img/product_31.041bcb4.webp";